import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { GraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { DebugFlagsDialogComponent } from './debug-flags-dialog/debug-flags-dialog.component';
import { DebugFlagsDialogService } from './services/debug-flags-dialog.service';
import { NgPipesModule } from 'ngx-pipes';
import * as i0 from "@angular/core";
export class ReusableUiFeatureFlagsModule {
    static { this.ɵfac = function ReusableUiFeatureFlagsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReusableUiFeatureFlagsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ReusableUiFeatureFlagsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [DebugFlagsDialogService], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatLegacyDialogModule,
            MatLegacyListModule,
            MatLegacyButtonModule,
            MatLegacyInputModule,
            MatLegacyCheckboxModule,
            MatLegacyAutocompleteModule,
            MatIconModule,
            AuthModule,
            GraphApiModule,
            DevelopmentModule,
            NgPipesModule] }); }
}
//# sourceMappingURL=reusable-ui-feature-flags.module.js.map